class ProductModel extends HTMLElement {
    constructor() {
      super();  
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  }
 customElements.define('product-model', ProductModel);
 
 class BarracudaRender extends HTMLElement {
    constructor() {
       super();
       this.page = this.getAttribute("page");
       this.section = this.getAttribute("section");
       if (this.page && this.section) {
          this.getContent();
       }
    }
    getContent() {
       console.log(this.page)
       axios.get(this.page+"?sections="+this.section)
          .then(function (response) {
             if (response.data) {
                Object.keys(response.data).forEach(function (el) {
                   this.innerHTML += response.data[el]
                }.bind(this))
             }
          }.bind(this))
          .catch(function (error) {
              console.error(error);
          });
    }
 }
 customElements.define('barracuda-render', BarracudaRender);
 
 class BarracudaProductGallery extends HTMLElement {
    constructor() {
       super();
       this.richMedia = []
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if(!this.initialized){
          this.initialized = true;
          //get current and all slides
          this.content = this.querySelector('.product-gallery-content');
          this.featuredProductGallery = this.closest(".featured-product-gallery");
          this.heightStyle = this.content.classList.contains("defined-height") ? (this.content.classList.contains("vh-product-gallery") ? 2 : 1) : false;
          this.thumbnails = this.querySelectorAll('.product-gallery-thumbnails>.thumbnail-media');
          this.thumbnails = this.thumbnails.length > 1 ? this.thumbnails : false;
          this.dots = this.querySelectorAll('.product-gallery-dots>.dot');
          this.slides = this.querySelectorAll('.product-media');
          if (this.querySelector('.product-media.current'))
             this.current = Array.from(this.slides).indexOf(this.querySelector('.product-media.current'))
          else {
             this.current = 0;
             this.slides[0].classList.add('current');
          }
          //if thumbnails on, select current
          if (this.thumbnails) this.thumbnailsGoto(this.thumbnails[this.current], this.current);
          //if dots on, select current
          if (this.dots) this.dotsGoto(this.current);
       
          //init height
          if(this.slides[this.current].querySelector("img")){
             this.slides[this.current].querySelector("img").addEventListener('load', ()=>{
                this.resize()
             })
          }
          this.resize();
          window.addEventListener('resize',this.resize.bind(this))
          
          //add Event listeners to controls
          if (this.slides.length > 1)
          {
             this.addAction(this.querySelector(".media-next"), this.next.bind(this))
             this.addAction(this.querySelector(".media-prev"), this.prev.bind(this))
          }
          this.addAction(this.querySelector(".media-zoom-in"), this.zoom.bind(this))
          this.addAction(this.querySelector(".media-zoom-out"), this.zoom.bind(this))
          if (this.thumbnails) {
             this.addAction(this.querySelector(".thumbnails-up"), this.thumbnailsGoto.bind(this, "up"))
             this.addAction(this.querySelector(".thumbnails-down"), this.thumbnailsGoto.bind(this, "down"))
          }
          if (this.dots) this.dots.forEach((dot, index) => {
             this.addAction(dot, this.goto.bind(this, index))
          })
          if (this.thumbnails) this.thumbnails.forEach((thumbnail, index) => {
             this.addAction(thumbnail, this.goto.bind(this, index))
          })
          this.content.querySelectorAll(".media-icon").forEach((btn) => {
             this.addAction(btn, this.mediaReplace.bind(this, btn))
          })
          this.addAction(this.querySelector(".media-close"), this.mediaClose.bind(this))
          //swipe
          if (typeof Swipe !== 'undefined') {
             new Swipe(this.content);
                this.content.addEventListener("swipe", this.swipe.bind(this));
          }
       }
    }
    addAction(item, fkc) {
       if (item) {
          item.addEventListener('click', (e) => {
             if(e.target.closest(":focus")) e.target.closest(":focus").blur()
             fkc()
          })
          item.addEventListener('keydown', (e) => {
             if (e.key == 'Space' || e.key == 'Enter') {
               item.click();
             }
          })
       }
    }
    swipe(e){
       if (e.detail && e.detail.direction)
          switch (e.detail.direction) {
             case "left":
                this.prev();
                break;
             case "right":
                this.next();
                break;
          }
    }
    next() {
       this.goto(this.current<(this.slides.length - 1)? this.current+1 : 0) 
    }
    prev() {
       this.goto(this.current > 0 ? this.current - 1 : this.slides.length - 1)
    }
    goto(target) {
       if (typeof target === 'string') {
          let targetEl = this.querySelector(target);
          target = Array.prototype.indexOf.call(this.slides, targetEl)
       }
       if (typeof target === 'number' && target >= 0 && !this.lock && target != this.current) {
          if (this.mediaOpen) {
             this.mediaClose();
             this.pauseMedia();
          }
          this.lock = true
          if (this.thumbnails) this.thumbnailsGoto(this.thumbnails[target], target);
          if (this.dots) this.dotsGoto(target);
          this.anime = anime.timeline({
             duration: 300,
             easing: 'linear'
          }).add({
             targets: this.slides[target],
             opacity: [0, 1]
          }, 0).add({
             targets: this.slides[this.current],
             opacity: [1, 0],
             complete: () => {
                this.slides[this.current].classList.remove('current');
                this.current = target;
                this.slides[this.current].classList.add('current');
                this.lock = false;
             }
          }, 0).add(!this.fullscreen? {
             targets: this.content,
             height: [this.content.offsetHeight,this.slides[target].scrollHeight + "px"],
          } : {}, 0).add((this.thumbnails && !this.fullscreen)? {
             targets: this.content.querySelector(".product-gallery-thumbnails"),
             maxHeight: [this.content.querySelector(".product-gallery-thumbnails").style.maxHeight,(Math.floor((this.slides[target].scrollHeight - 48 - 116) / 116) * 116) + "px" ]
          } : {}, 0)
       }
    }
    zoom() {
       if (this.fullscreen) {
          window.removeEventListener('keydown',this.fullscreenListener);
          this.content.classList.remove("fullscreen");
          anime({
             targets: this.content.querySelector(".thumbnails-navigation"),
             easing: "easeInOutSine",
             duration: 200,
             marginLeft: "0px",
             marginTop: "0px"
          })
          anime({
             targets: this.content.querySelector(".product-media.type-image.current"),
             easing: "easeInOutSine",
             duration: 200,
             height: [(el) => {
                if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return document.documentElement.clientHeight + "px";
                else
                   return document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio) + "px"
             }, ((el) => {
                if (this.content.classList.contains("adapt"))
                   return this.preZoom.width * parseFloat(el.querySelector("img").dataset.ratio)
                else
                   return this.preZoom.height
             }).bind(this)],
             width: [(el) => {
                if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight) + "px"
                else
                   return document.documentElement.clientWidth + "px"
             }, this.preZoom.width],
             marginLeft: [(el) => {
                if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return (document.documentElement.clientWidth - (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)) / 2
                else
                   return 0
             }, 0],
             marginTop: [(el) => {
                if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return 0
                else
                   return ((document.documentElement.clientHeight - (document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio))) / 2) + "px"
             }, 0],
             complete: (animation) => {
                let el = animation.animatables[0].target
                el.style.removeProperty("margin-left");
                el.style.removeProperty("margin-top");
                el.style.removeProperty("height")
                el.style.removeProperty("width")
             }
          })
          anime({
             targets: this.content,
             easing: "easeInOutSine",
             duration: 200,
             width: [ this.content.offsetWidth + "px", this.preZoom.width], 
             height: [ this.content.offsetHeight + "px", this.preZoom.height], 
             left: this.preZoom.left, 
             top: this.preZoom.top,
             complete: (() => {
                this.content.style.removeProperty("position");
                this.content.style.removeProperty("width");
                this.content.style.removeProperty("height");
                this.content.style.removeProperty("left");
                this.content.style.removeProperty("top");
                this.content.style.removeProperty("z-index");
                this.content.parentElement.parentElement.style.removeProperty("min-height");
                this.content.classList.remove("fullscreen");
                if(this.featuredProductGallery)
                   this.featuredProductGallery.style.removeProperty("z-index");
                if(this.heightStyle == 2) this.content.classList.add("vh-product-gallery");
                this.resize()
                unlockBodyPosition();
             }).bind(this)
          })
         
       } else {
          this.preZoom = {
             width: this.content.offsetWidth + "px",
             height: this.content.offsetHeight + "px",
             top: this.content.getBoundingClientRect().top + "px",
             left: this.content.getBoundingClientRect().left + "px"
          }
          this.content.style.position = "fixed";
          this.content.style.width = this.preZoom.width;
          this.content.style.height = this.preZoom.height;
          this.content.style.top = this.preZoom.top;
          this.content.style.left = this.preZoom.left;
          this.content.style.zIndex = 9;
          this.content.parentElement.parentElement.style.minHeight = this.preZoom.height;
 
          if (this.featuredProductGallery)
             this.featuredProductGallery.style.zIndex = 9;
          
          anime({
             targets: this.content.querySelector(".thumbnails-navigation"),
             easing: "easeInOutSine",
             duration: 200,
             marginLeft: "48px",
             marginTop: "48px"
          })
          anime({
             targets: this.content.querySelector(".product-media.type-image.current"),
             easing: "easeInOutSine",
             duration: 200,
             height: ((el) => {
                if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                {  return document.documentElement.clientHeight + "px"
                }else{
                   return document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio) + "px"}
             }).bind(this),
             width: (el) => { 
                if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)+"px"
                else
                   return document.documentElement.clientWidth + "px"
             },
             marginLeft: [0, (el) => { 
                if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return ((document.documentElement.clientWidth - (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)) / 2) + "px"
                else
                   return 0
             }],
             marginTop: [0, (el) => {
                if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                   return 0
                else
                   return ((document.documentElement.clientHeight - (document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio))) / 2) + "px"
             }],
             complete: (animation) => {
                console.log(animation);
                let el = animation.animatables[0].target
                el.style.removeProperty("margin-left");
                el.style.removeProperty("margin-top");
                el.style.removeProperty("height")
                el.style.removeProperty("width")
             }
          })
          anime({
             targets: this.content,
             easing: "easeInOutSine",
             duration: 200,
             left: 0,
             top: 0,
             height: document.documentElement.clientHeight + "px",
             width: document.documentElement.clientWidth + "px",
             complete: (() => {
                this.content.classList.add('fullscreen');
             }).bind(this)
          }) 
             this.fullscreenListener = ((e) => {
                switch (e.key) {
                   case "Escape":
                      this.zoom()
                      break;
                   case "ArrowRight":
                      this.next()
                      break;
                   case "ArrowLeft":
                      this.prev()
                      break;
                }
             }).bind(this);
             window.addEventListener('keydown', this.fullscreenListener);
             if(this.heightStyle == 2) this.content.classList.remove("vh-product-gallery");
          if (this.thumbnails) {
             this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc(" + Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) + " * 116px)";
             if ((Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
                this.querySelector(".thumbnails-controls").classList.add("hidden");
             } else{
                this.querySelector(".thumbnails-controls").classList.remove("hidden");
             }
          }
             lockBodyPosition();
             
       }
       this.fullscreen = !this.fullscreen;
    }
    thumbnailsGoto(target, position = null) {
       let thumbnailsGallery = this.querySelector(".product-gallery-thumbnails");
       switch (typeof target){ 
          case "string":
             target = target == "up" ? -1 * thumbnailsGallery.offsetHeight:  thumbnailsGallery.offsetHeight
             if (target < 0)
                target = thumbnailsGallery.scrollTop == 0 ? thumbnailsGallery.scrollHeight : thumbnailsGallery.scrollTop + target
             else if (target > 0)
                target = (thumbnailsGallery.scrollTop == (thumbnailsGallery.scrollHeight - thumbnailsGallery.offsetHeight)) ? 0 : thumbnailsGallery.scrollTop + target
             break;
          case "object":
             target = target.offsetTop;
             this.thumbnails.forEach((thumbnail, index) => { if (index != position) thumbnail.classList.remove("current"); else thumbnail.classList.add("current")})
             break;
       }
       anime({
          targets: thumbnailsGallery,
          scrollTop: target,
          duration: 1000,
          easing: "easeOutCubic"
       });
    }
    dotsGoto(target) {
       this.dots.forEach((dot, index)=>{
          if(index != target) dot.classList.remove("current");
          else dot.classList.add("current");
       })
 
       function dotsVisibility(from = null, to = null){
          if(this.dots.length>0){
             this.dots.forEach(dot=>{
                dot.classList.remove("end");
                dot.classList.add("visible");
             })
             if(from){
                for (let i = 0; i < from; i++) { if(this.dots[i]) this.dots[i].classList.remove("visible");}
                if(this.dots[from]) this.dots[from].classList.add("end");
             }
             if(to){
                for (let i = to; i < this.dots.length; i++){ if(this.dots[i]) this.dots[i].classList.remove("visible");}
                if(this.dots[(to-1)] && (to != this.dots.length)) this.dots[(to-1)].classList.add("end");
             }
          }
       }
       dotsVisibility = dotsVisibility.bind(this);
          
       var visibleDots = 5; // count of visible dots
       var dotsCount = this.dots.length;
       if(dotsCount <= visibleDots)
          dotsVisibility();
       else if(target < 3)
          dotsVisibility(null,visibleDots);
       else if((target + 3)> dotsCount)
          dotsVisibility((dotsCount-visibleDots),null);
       else
          dotsVisibility((target - 2),(target + 3))
       
    }
    mediaReplace(btn) {
       this.mediaOpen = true;
       let media = btn.parentElement.querySelector("template").content.firstElementChild.cloneNode(true)
       this.richMedia[this.current] = media.firstElementChild;
       btn.parentElement.appendChild(media);
       media.focus();
       btn.parentElement.querySelector("button").classList.add("hidden");
       this.content.querySelector(".thumbnails-navigation").classList.add("hidden");
       this.content.querySelectorAll(".media-zoom").forEach(el=>{el.classList.add("hidden")});
       this.content.querySelector(".media-close").classList.remove("hidden");
    }
    mediaClose() {
       this.mediaOpen = false;
       this.slides[this.current].querySelector(".product-media-frame").remove();
       this.slides[this.current].querySelector("button").classList.remove("hidden");
       this.content.querySelectorAll(".media-zoom").forEach(el=>{el.classList.remove("hidden")});
       this.content.querySelector(".thumbnails-navigation").classList.remove("hidden");
       this.content.querySelector(".media-close").classList.add("hidden");
       this.richMedia.splice(this.current, 1);
    }
    pauseMedia(){
       this.richMedia.forEach(el => {
          if (el) {
            if(el.classList.contains("js-youtube"))
                el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            else if(el.classList.contains("js-vimeo"))
                el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            else if(el.classList.contains("video"))
                el.pause();
          }
        })
    }
    resize() {
       if (this.fullscreen) {
          this.content.style.height = document.documentElement.clientHeight + "px"
          this.content.style.width = document.documentElement.clientWidth + "px"
          if (this.thumbnails) {
             this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc("+ Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) +" * 116px)";
             if ((Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
                this.querySelector(".thumbnails-controls").classList.add("hidden");
             } else{
                this.querySelector(".thumbnails-controls").classList.remove("hidden");
             }
          }
       } else {
          if (this.heightStyle < 1)
             this.content.style.height = this.slides[this.current].scrollHeight + "px"
          else if (this.heightStyle == 2)
             this.content.style.removeProperty("height")
          if (this.thumbnails) {
             this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc(" + Math.floor((this.slides[this.current].scrollHeight - 48 - 116) / 116) + " * 116px)";
             if ((Math.floor((this.slides[this.current].scrollHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
                this.querySelector(".thumbnails-controls").classList.add("hidden");
             }
          }
       }
    }
 }
 customElements.define('barracuda-product-gallery', BarracudaProductGallery);
 
 class BarracudaAnnouncementBar extends HTMLElement {
    constructor() {
        super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
           this.initialized = true;
           this.respawn = this.getAttribute("respawn");
            if (this && (getCookie('cookie-announcement-bar-' + this.respawn) == "closed" && !Shopify.designMode)) {
                this.classList.add("hide-by-cookie");
                document.documentElement.style.setProperty('--announcement-bar-height', 0 + "px");
            }else{
                this.time = this.getAttribute('time') ? parseInt(this.getAttribute('time')) * 1000 : 1200;
               this.content = this.querySelector(".announcement-bar-content");
               this.closed = false;
                this.current = 0;
                this.elements = this.querySelectorAll('.announcement');
                this.autoplay = (this.time && this.elements.length > 1)? this.time : false;
                this.resize();
                let closer = this.querySelector(".hide-by-cookie-toggle");
                if (closer) closer.addEventListener('click', this.close.bind(this));
                window.addEventListener("resize", this.resize.bind(this), false);
                    if (this.elements.length > 1) this.timeout = setTimeout(this.setNext.bind(this, this.current + 1), this.time);
            }
       }
    }
     close() {
         console.log("announcement closing");
        this.autoplay = false;
        this.closed = true;
        document.documentElement.style.setProperty('--announcement-bar-height', 0 + "px");
        this.content.style.height = parseInt(this.content.offsetHeight) + "px";
        this.content.style.overflow = "hidden";
        this.content.style.transition = "height 1s ease";
        this.content.style.minHeight = "0px";
         this.content.style.height = "0px";
        if(this.respawn > 0) setCookie('cookie-announcement-bar-' + this.respawn,"closed",this.respawn);
    }
    resize() {
       if (!this.closed)
       {
         this.height = 0
         this.elements.forEach(el => {
            if(el.firstElementChild.scrollHeight > this.height) this.height = el.firstElementChild.scrollHeight;
         })
         if (this.height > 48) {
            this.querySelector('.announcement-bar-content').style.height = this.height + "px"
            document.documentElement.style.setProperty('--announcement-bar-height', this.height + "px");
         } else {
            this.querySelector('.announcement-bar-content').style.height = 48 + "px"
            document.documentElement.style.setProperty('--announcement-bar-height', 48 + "px");
         }
       }
    }
    setNext(next = (this.current + 1), pause = false) {
       if (pause) clearTimeout(this.timeout);
       if(next != this.current){
          if (next >= this.elements.length) next = 0;
          this.elements[next].classList.add("current");
          this.elements[this.current].classList.remove("current")
          this.current = next;
       }
       if (!pause && this.autoplay) this.timeout = setTimeout(this.setNext.bind(this, this.current + 1), this.time);
    }
 }
 customElements.define('barracuda-announcement-bar', BarracudaAnnouncementBar);
 
 class BarracudaSubHeader extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.content = this.firstElementChild;
          this.opener = this.closest(".sub-header-opener");
          this.opener.addEventListener('mouseenter', this.mouseEnter.bind(this));
          this.opener.addEventListener('mouseleave', this.mouseLeave.bind(this));
          setTimeout(() => {
             this.content.querySelectorAll("img").forEach(el => {
                el.removeAttribute("loading");
             })
          },1000)
       }
    }
    mouseEnter() {
       let header = this.closest("#header")
       if(header.classList.contains("should-be-transparent")){
          header.classList.remove("should-be-transparent")
          header.classList.remove("can-be-transparent")
          header.classList.add("cant-be-transparent")
       }
    }
    mouseLeave() {
       let header = this.closest("#header")
       if(header.classList.contains("cant-be-transparent")){
          header.classList.remove("cant-be-transparent")
          header.classList.add("can-be-transparent")
          if(Barracuda.elements.Overlapping)
             Barracuda.elements.Overlapping.check();
       }
    }
 }
 customElements.define('barracuda-sub-header', BarracudaSubHeader);
 
 class BarracudaCarousel extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.content = this.querySelector(".carousel-grid")
          this.dots = this.querySelectorAll(".barracuda-dot")
          this.leftArrow = this.querySelector(".prev")
          this.rightArrow = this.querySelector(".next")
 
          this.leftArrow.addEventListener("click", this.prev.bind(this));
          this.rightArrow.addEventListener("click", this.next.bind(this));
          this.dots.forEach((el)=>{el.addEventListener("click", this.goTo.bind(this,el));});
          this.currentDot = this.dots[0];
          if (this.currentDot) this.currentDot.classList.add("current"); 
          setTimeout(this.resize.bind(this), 50);
          window.addEventListener("resize", this.resize.bind(this));
          this.content.addEventListener("scroll", this.updateDots.bind(this))
       }
    }
    goTo(dot) {
       if (dot.dataset.i != this.currentDot.dataset.i){
          anime({
             targets: this.content, 
             scrollLeft: this.content.querySelector(".small-block:nth-child("+dot.dataset.i+")").offsetLeft,
             easing: "easeInOutCubic",
             duration: Math.abs(this.content.querySelector(".small-block:nth-child("+dot.dataset.i+")").offsetLeft - this.content.querySelector(".small-block:nth-child("+this.currentDot.dataset.i+")").offsetLeft) * 0.75,
             complete: this.updateDots.bind(this)
          })  
       }
    }
    next() {
       console.log("next");
       anime({
          targets: this.content,
          scrollLeft: () => {
             if (this.content.scrollLeft == this.content.scrollWidth - (this.content.offsetWidth))
                return 0
             else
                return this.content.scrollLeft + (this.content.offsetWidth) 
          },
          easing: "easeInOutCubic",
          duration: (this.content.offsetWidth) * 0.75,
          complete: this.updateDots.bind(this)
       })  
    }
    prev() {
       console.log("prev");
       anime({
          targets: this.content,
          scrollLeft: () => {
             if (this.content.scrollLeft == 0) {
                console.log()
                return this.content.scrollWidth - (this.content.offsetWidth) 
             }else
                return this.content.scrollLeft - (this.content.offsetWidth)
          },
          easing: "easeInOutCubic",
          duration: (this.content.offsetWidth) * 0.75,
          complete: this.updateDots.bind(this)
       })
    }
    resize() {
       const columns = parseInt(getComputedStyle(this.content).getPropertyValue('--columns-count'));
       this.dots.forEach((el, index) => {
          if (index % columns == 0) {
             el.classList.add("active")
          } else{
             el.classList.remove("active")
          }  
       })
       this.updateDots();
    }
    updateDots() {
       let target = parseInt(Math.ceil((this.content.scrollLeft / (this.content.offsetWidth))))
       let currentDot = this.querySelectorAll(".barracuda-dot.active")[target]
       if (currentDot) {
          if (currentDot != this.currentDot) {
             this.currentDot.classList.remove("current");
             this.currentDot = currentDot;
             this.currentDot.classList.add("current"); 
          }
       }
 
       function dotsVisibility(dots, from = null, to = null){
          if (dots.length > 0) {
             dots.forEach(dot=>{
                dot.classList.remove("end");
                dot.classList.add("visible");
             })
             if(from){
                for (let i = 0; i < from; i++) { if(dots[i]) dots[i].classList.remove("visible");}
                if(dots[from]) dots[from].classList.add("end");
             }
             if(to){
                for (let i = to; i < dots.length; i++){ if(dots[i]) dots[i].classList.remove("visible");}
                if(dots[(to-1)] && (to != dots.length)) dots[(to-1)].classList.add("end");
             }
          }
       }
       dotsVisibility = dotsVisibility.bind(this);
          
       let dots = this.querySelectorAll(".barracuda-dot.active")
       var visibleDots = 5; // count of visible dots
       var dotsCount = dots.length;
       if(dotsCount <= visibleDots)
          dotsVisibility(dots);
       else if(target < 3)
          dotsVisibility(dots,null,visibleDots);
       else if((target + 3)> dotsCount)
          dotsVisibility(dots,(dotsCount-visibleDots),null);
       else
          dotsVisibility(dots,(target - 2),(target + 3))
    }
 }
 customElements.define('barracuda-carousel', BarracudaCarousel);
 
 class BarracudaPopupOpener extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.url = this.getAttribute("url");
          this.sectionSelector = this.getAttribute("section");
          if(this.url && this.sectionSelector) this.querySelector("a").addEventListener("click", this.open.bind(this));
       }
    }
    open(e) {
       prevent(e);
       axios.get(this.url)
          .then(function (response) {
             if (response.data) {
                var x = document.createElement("html");
                x.innerHTML = response.data;
                var source = x.querySelector(this.sectionSelector);
                if (source){
                   let target = document.querySelector(".overlay-content");
       
                   var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
                   if (currentContent && currentContent.dataset.source && document.querySelector("#" + currentContent.dataset.source))
                      document.querySelector("#" + currentContent.dataset.source).appendChild(currentContent);
 
                   target.innerHTML = "";
 
                   var closer = document.createElement("a");
                   closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
                   closer.classList.add("icon", "icon-x", "overlay-closer");
                      
                   var content = document.createElement("div");
                   content.appendChild(source)
                   content.classList.add("overlay-content-content", "scroll-inside");
                   if (source.dataset.type) content.classList.add(...source.dataset.type.split(" "));
                      
                   target.appendChild(closer);
                   target.appendChild(content);
 
                   if (content.querySelector(".map")) {
                      setTimeout(function () {
                         Barracuda.loadMapsScript(content);
                      }, 200);
                   }
 
                   Barracuda.init();
                   Barracuda.elements.init();
                   target.classList.remove("loading");
                   lockBodyPosition();
                   document.querySelector("body").classList.add("show-overlay");
                }
             }
          }.bind(this))
          .catch(function (error) {
             console.warn(error);
          });
          return false;
    }
 }
 customElements.define('barracuda-popup-opener', BarracudaPopupOpener);
 
 class BarracudaTabs extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.content = this.querySelector(".tabs-content")
          this.tabOpeners = this.querySelectorAll(".tab-opener");
          this.tabContents = this.querySelectorAll(".tab-content");
          this.current = parseInt(this.querySelector(".tab-opener.active").dataset.i);
          this.tabOpeners.forEach((el, key) => {
             el.addEventListener("click",this.showTab.bind(this, key));
          })
       }
    }
    showTab(i, animation = true) {
       console.log("Currrent: ", this.current, "Next: ", i);
       this.tabOpeners.forEach((el, key) => { if (i != key) el.classList.remove("active") })
       this.tabOpeners[i].classList.add("active");
 
       if(animation){
          anime.timeline({
             duration: 300,
             easing: "linear"
          }).add({
             targets: this.tabContents[this.current],
             opacity: [1, 0],
             maxHeight: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
             before: function () {
                this.tabContents[this.current].style.width = this.tabContents[this.current].offsetWidth + "px";
                this.tabContents[this.current].style.position = "absolute";
                this.tabContents[this.current].style.overflow = "hidden";
             }.bind(this),
             complete: function () {
                this.tabContents[this.current].classList.remove("active");
                this.tabContents[this.current].style.removeProperty("position");
                this.tabContents[this.current].style.removeProperty("width");
                this.tabContents[this.current].style.removeProperty("max-height");
                this.tabContents[this.current].style.removeProperty("overflow");
             }.bind(this)
          },0).add({
             targets: this.content,
             height: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
             complete: function () {
                this.content.style.removeProperty("height");
             }.bind(this)
          },0).add({
             targets: this.tabContents[i],
             opacity: [0, 1],
             maxHeight: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
             complete: function () {
                this.tabContents[i].classList.add("active");
                this.tabContents[i].style.removeProperty("max-height");
                this.current = i;
             }.bind(this)
          }, 0);
       } else {
          this.tabContents.forEach((el, key) => { if(i != key) el.classList.remove("active") })
          this.tabContents[i].classList.add("active");
       }
    }
    customize(i) {
       this.showTab(i, false)
    } 
 }
 customElements.define('barracuda-tabs', BarracudaTabs);
 
 class BarracudaProductRecommendations extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.url = document.querySelector('body').dataset.url + this.dataset.url;
          this.hasContent = this.dataset.hasContent;
          if(this.hasContent == "false")
          axios.get(this.url)
             .then(function (response) {
                if (response.data) {
                   var x = document.createElement("html");
                   x.innerHTML = response.data;
                   let betterOne = x.querySelector("barracuda-product-recommendations");
                   if(betterOne.firstElementChild)
                      this.appendChild(betterOne.firstElementChild);
                   this.hasContent = true;
                }
             }.bind(this))
             .catch(function (error) {
                console.warn(error);
             });
       }
    } 
 }
 customElements.define('barracuda-product-recommendations', BarracudaProductRecommendations);
 
 if (typeof BarracudaMarketSelector !== 'class'){
    class BarracudaMarketSelector extends HTMLElement {
        constructor() {
            super();
        
            this.initialized = false;
            if (document.querySelector("body").classList.contains("script"))
                this.init()
            else
                window.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
        init() {
            if (!this.initialized) {
                this.initialized = true;
                this.select = this.querySelector("select");
                this.select.addEventListener("mousedown", this.addOptions.bind(this));
               this.select.addEventListener("change", this.change.bind(this));
            }
        }
        addOptions() {
            let offsetWidth = this.select.offsetWidth;
          let value = this.select.value;
            if(offsetWidth > 0) this.select.style.width = (offsetWidth - parseInt(this.select.style.paddingRight)) + "px";
            this.querySelectorAll("select+select option").forEach((el)=>{
                this.select.appendChild(el);
            })
          this.select.value = value;
            this.select.removeEventListener("mousedown", this.addOptions.bind(this)); 
        }
        change(){
            this.closest("form").submit();
        }
    }
    customElements.define('barracuda-market-selector', BarracudaMarketSelector);
 }
 
 class BarracudaSmallBlockBadges extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.content = this.querySelector(".content");
          this.badges = this.querySelectorAll(".small-block-badge");
          this.opener = this.querySelector(".open");
          this.closer = this.querySelector(".close");
 
          if (this.content && this.badges && this.opener && this.closer) {
             this.resize();
             window.addEventListener("resize", this.resize.bind(this));
             this.opener.addEventListener("click", this.toggle.bind(this));
             this.closer.addEventListener("click", this.toggle.bind(this));
          }
       }
    }
    resize() {
       if (this.content.scrollHeight == this.content.offsetHeight) {
          this.classList.remove("opened","closed")
       } else {
          this.classList.add("closed");
          this.opener.style.removeProperty("order");
          let filled_width = 0;
          this.badges.forEach((el, index) => {
             console.log(el,index, ": ", filled_width + el.offsetWidth," < ", this.content.offsetWidth - 30)
             if (filled_width + el.offsetWidth <= this.content.offsetWidth - 30) {
                this.opener.style.order = index + 1;
                filled_width += el.offsetWidth + 6;
             }
          }) 
       }
    }
    toggle(event, animation = true) {
       console.log(event);
       event.preventDefault()
       if (this.classList.contains("closed")) {
          /* open list */
          this.classList.add("opened");
          this.classList.remove("closed");
          this.original_height = this.content.offsetHeight;
          this.anime = anime.timeline({
             duration: 100,
             easing: 'linear'
          }).add({
             targets: this.content,
             height: [this.content.offsetHeight + 'px', (this.content.scrollHeight + 5) + 'px']
          }, 0)
       } else {
          /* close list */
          this.classList.add("closed");
          this.classList.remove("opened");
          this.anime = anime.timeline({
             duration: 100,
             easing: 'linear'
          }).add({
             targets: this.content,
             height: [this.content.scrollHeight+ 'px', this.original_height+ 'px']
          }, 0)
       }
    }
 }
 customElements.define('barracuda-small-block-badges', BarracudaSmallBlockBadges);
 
 
 class BarracudaInputDate extends HTMLElement {
    constructor() {
       super();
       this.initialized = false;
       if (document.querySelector("body").classList.contains("script"))
          this.init()
       else
          window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
    init() {
       if (!this.initialized) {
          this.initialized = true;
          this.inputs = this.querySelectorAll("input")
          this.values = ["", "", ""];
          this.parent = this.getAttribute("input") ? document.querySelector("#" + this.getAttribute("input")) : false;
          
          if(this.parent)
          this.inputs.forEach((input, index) => {
             input.addEventListener("keyup",this.change.bind(this, input, index))
             input.addEventListener("change",this.change.bind(this, input, index))
          });
          this.querySelector("span").addEventListener("click", this.focusInput.bind(this));
       }
    }
    focusInput() {
       this.inputs[0].focus();
    }
    change(input, index) {
       let value = parseInt(input.value);
       value = value? value : (value == 0? value : "");
       this.values[index] = value;
       input.value = value;
       
       let day = ("0" + this.values[0]).slice(-2);
       let month = ("0" + this.values[1]).slice(-2);
       let year =  ("0" + this.values[2]).slice(-4);
 
       this.parent.value = (year)+"-"+(month)+"-"+(day) ;
    }
 }
customElements.define('barracuda-input-date', BarracudaInputDate);
 

customElements.define('barracuda-icon',  class extends HTMLElement {
   constructor() {
      super();
      this.icon = this.getAttribute("icon");
      if(feather && feather.icons[this.icon])
      this.innerHTML = feather.icons[this.icon].toSvg()
   }
});

customElements.define('barracuda-cookies-popup', class extends HTMLElement {
   constructor() {
      super();
      this.content = this.querySelector("#cookies-popup-content")
      console.log("Cookies state: ",getCookie('cookie-bar'))
      switch (getCookie('cookie-bar')) {
         case 'confirm':
            Barracuda.cookies = Object.assign(Barracuda, { 'cookies': { 'accepted': true, 'rejected': false } })
            break;
         case 'reject':
            Barracuda.cookies = Object.assign(Barracuda, { 'cookies': { 'accepted': false, 'rejected': true }})
            break;
         default:
            Barracuda.cookies = Object.assign(Barracuda, { 'cookies': { 'accepted': false, 'rejected': false }})
            this.show();
      }
      this.querySelector("#cookies-popup-confirm-button").addEventListener("click", this.hide.bind(this, true, 'confirm'));
      let xButton = this.querySelector(".icon.icon-x")
      if(xButton) xButton.addEventListener("click", this.hide.bind(this, true, 'reject')) 
   }
   show() {
      setTimeout(() => {
      Barracuda.fadeIn(this.content,()=>{
         this.content.classList.remove("hide");
      }, (Barracuda.duration * 2));
      }, 1000)
   }
   hide(useCookie = false, state = 'confirm') {
      console.log("params: ", useCookie, state, " cookie function:", setCookie)
      if(useCookie) 
         setCookie("cookie-bar", state ,120);
      Barracuda.fadeOut(this.content,()=>{
            this.content.classList.add("hide");
      }, (Barracuda.duration * 2));
   }
})

customElements.define("barracuda-quick-view-opener", class extends HTMLElement{
   constructor() {
      super();
      this.addEventListener("click", this.click.bind(this), false)
      this.product = this.getAttribute("product");
   }
   click(e) {
      if (!e.target.closest(".prevent-quickview")){
         prevent(e);
         let openButton = e.target.closest(".button");
         if (openButton) openButton.classList.add("loading")
         var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
         if (currentContent && currentContent.dataset.source) {
           var t = document.querySelector("#" + currentContent.dataset.source);
           if (t) t.appendChild(currentContent);
         }
         let content = document.querySelector(".overlay-content");
         content.innerHTML = "";
         content.classList.add("loading")
         lockBodyPosition();
         let url = this.product ? this.product + (this.product.includes("?") ? '&sections=product-lightbox' : '?sections=product-lightbox') : false;
         axios.get(url ? url : '/products/?sections=product-lightbox')
           .then(function (response) {
             var code = response.data ? (response.data['product-lightbox'] ? response.data['product-lightbox'] : false) : false;
             if (code) {
               content.classList.remove("loading")
               content.innerHTML = code;
               Barracuda.elements.init();
               barracudaCart.appendAddToCartButton(document.querySelector(".overlay-content").querySelector(".barracuda-cart-addToCartButton"));
               document.querySelector("body").classList.add("show-overlay");
             }
             if (openButton) openButton.classList.remove("loading")
           })
           .catch(function (error) {
             unlockBodyPosition();
             console.log(error);
             if (openButton) openButton.classList.remove("loading")
           });
         return false;
      } 
   }
})